/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { pull } from 'lodash';
import {
  DetailItem,
  Heading,
  QuoteStructureItem,
  QuoteStructureSelectedObject,
} from '../../../../resources/quote-structure.model';
import {
  QuoteStructureDetailsDialogConfig,
  quoteStructureDetailsDialogRoute,
} from '../quote-structure-details-dialog/quote-structure-details-dialog.component';

@Component({
  standalone: false,
  selector: 'gh-quote-structure-heading',
  templateUrl: 'quote-structure-heading.component.html',
  styleUrls: ['quote-structure-heading.component.scss'],
})
export class QuoteStructureHeadingComponent {
  @Input() heading: Heading;
  @Input() selectedObject: QuoteStructureSelectedObject;

  @Output() select = new EventEmitter<QuoteStructureSelectedObject>();
  @Output() change = new EventEmitter<Heading>();

  collapsed: boolean = true;

  constructor(private dialogService: DialogService) {
  }

  get haveChild(): boolean {
    return this.heading.details && this.heading.details.length > 0 ||
      this.heading.items && this.heading.items.length > 0;
  }

  addDetail(item?: QuoteStructureItem): void {
    this.dialogService.openWithInput(quoteStructureDetailsDialogRoute, <QuoteStructureDetailsDialogConfig>{})
      .afterClosed().pipe(
      filter$(Boolean))
      .subscribe((detail: DetailItem) => {
        detail.hide = false;
        if (item) {
          item.details.push(detail);
        } else {
          this.heading.details.push(detail);
        }
        this.change.emit(this.heading);
      });
  }

  elementSelected(item: QuoteStructureItem): void {
    this.select.emit({
      heading: this.heading,
      item,
    });
  }

  onDetailEdited(editingDetails: DetailItem): void {
    this.dialogService.openWithInput(quoteStructureDetailsDialogRoute, <QuoteStructureDetailsDialogConfig>{
        detail: editingDetails,
      })
      .afterClosed().pipe(
      filter$(Boolean))
      .subscribe((detail: DetailItem) => {
        editingDetails.description = detail.description;
        this.change.emit(this.heading);
      });
  }

  onDetailRemoved(detail: DetailItem, item?: QuoteStructureItem): void {
    if (item) {
      pull(item.details, detail);
    } else {
      pull(this.heading.details, detail);
    }
    this.change.emit(this.heading);
  }

  onCollapsedChange($event: MouseEvent): void {
    $event.preventDefault();

    this.collapsed = !this.collapsed;
  }

  onSelectHeading(): void {
    this.select.emit({
      heading: this.heading,
      item: void 0,
    });
  }
}
